import React, { useEffect, useState } from "react"
import ConfirmModal from "../ConfirmModal/ConfirmModal"
import { isClosedStatus } from "./leadStatus"

const MAX_REASON = 500

const LeadStatusConfirm = ({ open, setOpen, status, onConfirm }) => {
  const [reason, setReason] = useState("")
  const closed = isClosedStatus(status)
  const statusId = status?._id

  useEffect(() => {
    setReason("")
  }, [open, statusId])

  const handleConfirm = () => {
    const text = closed ? reason.trim() : ""
    onConfirm({ reason: text || undefined })
  }

  return (
    <ConfirmModal
      className="min-w-[400px] min-h-[200px]"
      title="Change Lead Status"
      modalButtonTitle="Change"
      open={open}
      setOpen={setOpen}
      functionButton={handleConfirm}
    >
      <p>Are you sure you want to change the lead status?</p>
      {closed && (
        <div className="mt-4">
          <label htmlFor="lead-status-reason" className="block text-sm mb-1">Reason (optional)</label>
          <textarea
            id="lead-status-reason"
            className="w-full border border-divider rounded-lg p-2 bg-transparent text-text-primary"
            rows={3}
            maxLength={MAX_REASON}
            value={reason}
            onChange={(event) => setReason(event.target.value)}
          />
        </div>
      )}
    </ConfirmModal>
  )
}

export default LeadStatusConfirm
